import React from 'react'
import PropTypes from 'prop-types'
const TooltipIcon = (props) => {

    return (
        <svg width="18" height="18" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 0C4.032 0 0 4.03731 0 9.01185C0 13.9864 4.032 18.0237 9 18.0237C13.968 18.0237 18 13.9864 18 9.01185C18 4.03731 13.968 0 9 0ZM9.9 13.5178H8.1V8.11066H9.9V13.5178ZM9.9 6.30829H8.1V4.50592H9.9V6.30829Z" fill={props.fill}/>
        </svg>
    )
}
TooltipIcon.propTypes = {
    fill: PropTypes.string
}
export default TooltipIcon
